import React from 'react'
import Dropdown from '../../../partials/Dropdown'
// Removed Modal import; using inline modal structure for consistency
import { trans } from '../../../../_providers/Translation'
import Api from '../../../../_helpers/Api'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"


function AddInStorageModal({ open, onClose, product, onSubmit, loading, validations }) {
    if (!open) return null

    return (
        <div className={open ? 'visible overlay' : 'overlay'}>
            <form className="show popup-primary large" autoComplete="off" onSubmit={onSubmit} style={{ display: open ? 'block' : 'none' }}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.addInStorage') || 'Add in Storage'}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={onClose}>

                    </span>
                </div>

          
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.id') || 'ID'}</label>
                            <input type="text" value={product?.id || ''} disabled />
                        </div>
                        <div className="col">
                            <label>{trans('labels.name') || 'Name'}</label>
                            <input type="text" value={product?.name || ''} disabled />
                        </div>
                        <div className="col">
                            <label>{trans('labels.category') || 'Category'}</label>
                            <input type="text" value={product?.category?.name || ''} disabled />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.number') || 'Number'}</label>
                            <input type="text" value={product?.number || ''} disabled />
                        </div>
                        {/* Add more disabled fields as needed */}
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.supplier')}</label>
                            <Dropdown
                                inputName="supplier"
                                inputIdName="supplier_id"
                                url="suppliers/all"
                                renderText={data => data.name}
                                //  onChange={data => handleStoreloadRowChange(idx, 'supplier_id', data.id)}
                            />
                        </div>
                        <div className="col">
                            <label>{trans('labels.factureOfSupplier')}</label>
                            <input
                                type="text"
                                name="po_number"
                                className={validations?.po_number ? 'validate' : ''}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.quantity') || 'Quantity'}</label>
                            <input
                                type="number"
                                name="quantity"
                                className={validations?.quantity ? 'validate' : ''}
                                defaultValue={1}
                                min={1}
                                required
                            />
                        </div>
                        <div className="col">
                            <label>{trans('labels.storage') || 'Storage'}</label>
                            <Dropdown
                                inputName="storage"
                                inputIdName="storage_location_id"
                                inputValue={product?.storage?.name || ''}
                                inputIdValue={product?.storage_location_id || ''}
                                url="storages/all"
                                renderText={data => data.name}
                                inputClassName={validations?.storage_location_id ? 'validate' : ''}
                                required
                            />
                        </div>
                        <div className="col">
                            <label>{trans('labels.comment') || 'Comment'}</label>
                            <input
                                type="text"
                                name="comment"
                                className={validations?.comment ? 'validate' : ''}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.deliveryPrice') || 'Delivery Price'}</label>
                            <input
                                type="number"
                                name="delivery_price"
                                className={validations?.delivery_price ? 'validate' : ''}
                                defaultValue={1}
                                min={1}
                                required
                            />
                        </div>
                          <div className="col">
                            <label>{trans('labels.batch')}</label>
                                <input
                                    type="text"
                                    name="batch_number"
                                    className={validations?.batch_number ? 'validate' : ''}
                                />
                        </div>
                        <div className="col">
                            <label>{trans('labels.reason') || 'Reason'}</label>
                            <select
                                name="reason"
                                className={validations?.reason ? 'validate' : ''}
                                required
                            >
                                <option value="load">{trans('random.load') || 'Load'}</option>
                                <option value="return_customer">{trans('random.returnFromCustomer') || 'Return from customer'}</option>
                                <option value="return_tech">{trans('random.returnFromTech') || 'Return from tech'}</option>
                            </select>
                        </div>
                    </div>
               
                <div className="footer align-right">
                    {loading ? (
                        <span>{trans('loading') || 'Loading...'}</span>
                    ) : (
                        <>
                            <button className="button" type="button" onClick={onClose}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    )}
                </div>
            </form>
        </div>
    )
}

export default AddInStorageModal
